import { render, staticRenderFns } from "./about.vue?vue&type=template&id=3bf6ef7c&scoped=true&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style0 from "./about.vue?vue&type=style&index=0&id=3bf6ef7c&scoped=true&lang=css&"
import style1 from "./about.vue?vue&type=style&index=1&id=3bf6ef7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf6ef7c",
  null
  
)

export default component.exports